<app-call-window [open]="visible" [title]="'ss.title' | t" [subtitle]="subtitle" (closed)="onHide()">

  <!-- the page's own buttons, in the thin top bar -->
  <span cwActions class="ssr-actions" *ngIf="state === 'live'">
    <button type="button" class="ssr-btn" *ngIf="mode === 'customer'" [class.on]="helpOpen" (click)="helpOpen = !helpOpen">
      <i class="pi pi-question-circle"></i><span>{{ 'ss.howTitle' | t }}</span>
    </button>
    <button type="button" class="ssr-btn" (click)="openInTab()" [title]="'ss.frameHint' | t">
      <i class="pi pi-external-link"></i><span>{{ 'ss.openTab' | t }}</span>
    </button>
    <button type="button" class="ssr-btn ssr-end" [disabled]="stopping" (click)="stop()">
      <i class="pi pi-stop-circle"></i><span>{{ mode === 'customer' ? ('ss.stop' | t) : 'End session' }}</span>
    </button>
  </span>

  <div class="ssr-center" *ngIf="state === 'joining'">
    <p-progressSpinner strokeWidth="4" [style]="{ width: '34px', height: '34px' }"></p-progressSpinner>
    <span>{{ 'ss.joining' | t }}</span>
  </div>

  <div class="ssr-center ssr-error" *ngIf="state === 'error'">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ errorText }}</span>
    <button pButton type="button" icon="pi pi-refresh" [label]="'ss.retry' | t" class="p-button-sm" (click)="retry()"></button>
  </div>

  <!-- live: the call fills everything below the bar -->
  <ng-container *ngIf="state === 'live'">
    <iframe *ngIf="frameUrl" class="ssr-frame" [src]="frameUrl" title="Screen support"
            allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write"></iframe>

    <!-- customer: how to share. A small card over the call that can be closed and reopened from the bar. -->
    <aside class="ssr-help" *ngIf="mode === 'customer' && helpOpen" role="region" [attr.aria-label]="'ss.howTitle' | t">
      <button type="button" class="ssr-help-x" (click)="helpOpen = false" aria-label="Close"><i class="pi pi-times"></i></button>
      <ng-container *ngIf="canShare; else noShare">
        <div class="ssr-help-title"><i class="pi pi-desktop"></i> {{ 'ss.howTitle' | t }}</div>
        <ol>
          <li>{{ 'ss.step1' | t }}</li>
          <li>{{ 'ss.step2' | t }}</li>
          <li>{{ 'ss.step3' | t }}</li>
        </ol>
      </ng-container>
      <ng-template #noShare>
        <div class="ssr-help-title ssr-warn"><i class="pi pi-mobile"></i> {{ 'ss.noShare' | t }}</div>
      </ng-template>
    </aside>

    <!-- support: a small reminder, out of the way -->
    <div class="ssr-chip" *ngIf="mode === 'staff'">
      <i class="pi pi-shield"></i> The customer was asked to share only their LumberLinq browser tab. If you see anything else, end the session.
    </div>
  </ng-container>
</app-call-window>
